import axios, { AxiosError } from 'axios';
import { useCallback, useState } from 'react';
import { useAxios, apiEndpoints } from 'api';
import { AutoAlertStatus } from 'components';
import {
  TrainingsEmployee,
  TrainingsEmployeeAdditionalParam,
  TrainingsUpcoming,
} from 'api/types/Trainings';

const useGetTrainings = (
  onError?: (error: AxiosError<Error>) => void
): [
  (additionalParam: TrainingsEmployeeAdditionalParam) => void,
  { [key: string]: TrainingsEmployee[] } | null | undefined
] => {
  const ax = useAxios();
  const [getedData, setGetedData] = useState<
    { [key: string]: TrainingsEmployee[] } | null | undefined
  >(undefined);

  const doGet = useCallback(
    (additionalParam: TrainingsEmployeeAdditionalParam) => {
      ax.get<{ [key: string]: TrainingsEmployee[] }>(
        `${apiEndpoints.employeeKiosk}/user/${additionalParam.userId}/training/current`
      )
        .then(({ data }) => {
          setGetedData(data);
        })
        .catch((error) => {
          if (error.response) {
            AutoAlertStatus({
              status: error.response.status,
              customMsg: JSON.parse(error.response?.request.response).message,
            });
          }
          if (onError) onError(error);
        });
    },
    [ax, onError]
  );

  return [doGet, getedData];
};

const useGetTrainingsUpcoming = (
  onError?: (error: AxiosError<Error>) => void
): [
  (additionalParam: TrainingsEmployeeAdditionalParam) => void,
  TrainingsUpcoming | null | undefined
] => {
  const ax = useAxios();
  const [getedData, setGetedData] = useState<
    TrainingsUpcoming | null | undefined
  >(undefined);

  const doGet = useCallback(
    (additionalParam: TrainingsEmployeeAdditionalParam) => {
      ax.get<TrainingsUpcoming>(
        `${apiEndpoints.employeeKiosk}/user/${additionalParam.userId}/training/upcoming`
      )
        .then(({ data }) => {
          setGetedData(data);
        })
        .catch((error) => {
          if (error.response) {
            AutoAlertStatus({
              status: error.response.status,
              customMsg: JSON.parse(error.response?.request.response).message,
            });
          }
          if (onError) onError(error);
        });
    },
    [ax, onError]
  );

  return [doGet, getedData];
};

export default {
  useGetTrainings,
  useGetTrainingsUpcoming,
};
